class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.autoClose = this.getAttribute('cart-auto-close') === 'true';
    this.autoCloseDelay = Number(this.getAttribute('cart-notification-timer')) || 5000;

    this.autoCloseTimeout = null;

    this.toggleElementSelector = this.getAttribute('cart-toggle-button');
    this.toggleElement = document.getElementById(this.toggleElementSelector);

    this.closeButtonSelector = this.getAttribute('cart-close-button');
    this.closeButton = document.getElementById(this.closeButtonSelector);

    if (this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));

    this.notification = document.getElementById('cart-notification');
    this.timerBar = this.notification.querySelector('.cart-notification__timer-bar');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    if (this.toggleElement) this.toggleElement.addEventListener('click', () => this.toggleButtonClick());

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.notification.addEventListener('mouseenter', () => this.clearAutoClose());
    this.notification.addEventListener('touchstart', () => this.clearAutoClose(), { passive: true });
    this.notification.addEventListener('pointerdown', () => this.clearAutoClose());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

  }


  toggleButtonClick() {
    if (this.notification.classList.contains('active')) {
      this.close();
    } else {
      this.open();
    }
  }

  open(initAutoClose = false) {
    this.clearAutoClose();
    
    document.body.classList.add('overflow-hidden-mobile');

    this.notification.classList.add('animate');

    requestAnimationFrame(() => {
      this.notification.classList.add('active');
      document.body.addEventListener('click', this.onBodyClick);
      if(initAutoClose) this.startAutoClose();
      if (this.toggleElement) this.toggleElement.classList.add('active');
      if (this.closeButton) this.closeButton.classList.add('active');
      console.log('cart notification opened',this.closeButton);
    });

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

  }

  close() {
    this.clearAutoClose();

    this.notification.classList.remove('active');
    if (this.toggleElement) this.toggleElement.classList.remove('active');
    if (this.closeButton) this.closeButton.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    document.body.classList.remove('overflow-hidden-mobile');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.variantId;
      if (!this.cartItemKey) return;
      this.getSectionsToRender().forEach((section => {
        const element =  document.getElementById(section.id)
        const html = parsedState.sections?.[section.id] || parsedState[section.id];
        if (!element || !html) return;
        if(this.cartItemKey && section.selector) {
          element.innerHTML = this.getSectionInnerHTML(html, section.selector);
        } else {
          element.innerHTML = this.getSectionInnerHTML(html);
        } 
          
      }));

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
      );

      if (this.header) this.header.reveal();
      this.open(true);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-price',
        selector: `[id="cart-notification-price-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;

    if (this.notification.contains(target) || target.closest('.header__icon--cart')) {
      this.clearAutoClose();
      return;
    }

    const disclosure = target.closest('details-disclosure, header-menu');
    this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  startAutoClose() {
    if (!this.autoClose || !this.timerBar) return;
    this.timerBar.style.animation = "none";
    this.timerBar.offsetHeight; 
    this.timerBar.style.animation = `cartTimer ${this.autoCloseDelay}ms linear forwards`;
    this.timerBar.classList.add('animate');
    this.autoCloseTimeout = setTimeout(() => {
      this.close();
    }, this.autoCloseDelay);
  }

  clearAutoClose() {
    if (!this.autoClose || !this.autoCloseTimeout) return;
    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = null;
    if (this.timerBar) {
      this.timerBar.style.animation = "none";
      this.timerBar.classList.remove('animate');
    }
  }

}

customElements.define('cart-notification', CartNotification);